import { render } from "./layout.vue?vue&type=template&id=564229e0&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=564229e0&lang=less&scoped=true"

import exportComponent from "D:\\pwrd\\gw-future\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564229e0"]])

export default __exports__